import { handleSuccessToast } from 'src/components/molecules';
import { ReactStateHook } from 'src/components/organisms/RoutingRule/hooks';
import { usePreventNavigation } from 'src/hooks';

interface Params {
  unsavedRulesExist: boolean;
  setUnsavedRulesExist: ReactStateHook<boolean>;
  setSaveRulesBeforeLeaving: ReactStateHook<boolean>;
  setLeavingPage: ReactStateHook<boolean>;
  allRulesAreSaved: boolean;
}

export const useLeaveRoutingPage = ({
  unsavedRulesExist,
  setUnsavedRulesExist,
  setSaveRulesBeforeLeaving,
  setLeavingPage,
  allRulesAreSaved,
}: Params) => {
  const onLeaveRoutingPage = (checkUnsavedRulesCallback: () => boolean) => {
    const unsavedRule = checkUnsavedRulesCallback();
    setUnsavedRulesExist(unsavedRule);
    setPreventNavigation(unsavedRule);
  };

  const onSave = () => {
    setSaveRulesBeforeLeaving(true);
    if (unsavedRulesExist) {
      setUnsavedRulesExist(false);
    }
    onLeave();
    if (allRulesAreSaved) {
      handleSuccessToast({
        toastMessage: 'Rules successfully saved.',
      });
    }
    setPreventNavigation(false);
  };

  const onDismiss = () => {
    setSaveRulesBeforeLeaving(false);
    setUnsavedRulesExist(false);
    onLeave();
    setPreventNavigation(false);
  };

  const {
    showCancellationModal,
    setNextLocation,
    onLeave,
    setShowCancellationModal,
    setPreventNavigation,
  } = usePreventNavigation(true, '/routing', true, setLeavingPage);

  return {
    onLeaveRoutingPage,
    onSave,
    onDismiss,
    showCancellationModal,
    setNextLocation,
    setShowCancellationModal,
  };
};
